export default {
  messageList: [],
  srchParam: {},
  messageUpdatePopup: false,
  messageInfo: { compId: '' },
};
